import React from 'react';
import { motion } from 'framer-motion';

export function Progress({ 
    value = 0, 
    max = 100, 
    showLabel = false, 
    size = 'md',
    color = 'var(--accent)',
    className = '' 
}) {
    const percentage = Math.min(100, Math.max(0, (value / max) * 100));

    const sizeClasses = {
        sm: 'h-1.5',
        md: 'h-2.5',
        lg: 'h-4'
    };

    return (
        <div className={`w-full flex flex-col gap-1.5 ${className}`}>
            {showLabel && (
                <div className="flex justify-between items-center text-xs font-medium text-[var(--text-secondary)]">
                    <span>Progress</span>
                    <span>{Math.round(percentage)}%</span>
                </div>
            )}
            <div className={`w-full bg-[var(--bg-muted)] rounded-full overflow-hidden ${sizeClasses[size]}`}>
                <motion.div 
                    initial={{ width: 0 }}
                    animate={{ width: `${percentage}%` }}
                    transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                    className="h-full rounded-full"
                    style={{ backgroundColor: color }}
                />
            </div>
        </div>
    );
}

export function Skeleton({ 
    className = '', 
    variant = 'rectangular', // 'rectangular', 'circular', 'text'
    width,
    height
}) {
    const variantClasses = {
        rectangular: 'rounded-xl',
        circular: 'rounded-full',
        text: 'rounded-md'
    };

    return (
        <div 
            className={`
                bg-[var(--bg-muted)] animate-pulse
                ${variantClasses[variant]}
                ${className}
            `}
            style={{ 
                width: width || (variant === 'text' ? '100%' : undefined),
                height: height || (variant === 'text' ? '1em' : undefined)
            }}
        />
    );
}
